import React from 'react'


const Ubicacion = () => {
  return (
    <div id='ubicacion' className='about-section-container'>
    <div className='about-background-image-container'>
                              
    </div>
    <div className='about-section-text-container'>
        <h1 className='primary-heading'>¿Dónde se realizará el curso?</h1>
        <p className='primary-subheading'>El curso se dará en:<br /> Calle Mercaderes 114 - Santiago de Surco</p>
        <div className='about-buttons-container'>
            
            
        </div>
    </div>    
    <div className='about-section-image-container'>
    <iframe
      title="Google Maps"
      width="600"
      height="450"
      loading="lazy"
      allowFullScreen
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.7477449354055!2d-76.9842046!3d-12.129404399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105b8759f6a4359%3A0x5fa04c36083805d4!2sCa.%20Mercaderes%20114%2C%20Lima%2015039!5e0!3m2!1ses-419!2spe!4v1712556956788!5m2!1ses-419!2spe"

    ></iframe>
    </div>

    
 </div>
  )
    
}  

export default Ubicacion;